<template>
  <div id="app">
    <!-- Only render components if eventData is loaded -->
    <div v-if="isLoadingEventData">Loading data...</div>
    <div v-else-if="!isLoadingEventDataFailed">
      <div v-if="eventData || !eventId"><DynamicHeadline /><div class="content"><AppSidebar /></div></div>
      <div v-else><div>Can't get data from event id={{ eventId }}, please check it</div></div>
    </div>
    <div v-else>
      <pre>{{ eventDataError }}</pre>
    </div>
  </div>
</template>

<script>
import DynamicHeadline from './components/DynamicHeadline.vue';
import AppSidebar from './components/AppSidebar.vue';
import auth from "@/auth";
// import DynamicContent from './components/DynamicContent.vue';

export default {
  name: 'App',
  components: {
    DynamicHeadline,
    AppSidebar,
    // DynamicContent,
  },
  data() {
    return {
      eventId: null
    };
  },
  mounted() {
  const queryParams = new URLSearchParams(window.location.search);

  const eventId = queryParams.get('event_id');
  const apiKey = queryParams.get('api_key');
  const market = queryParams.get('market');
  const service = queryParams.get('service');
  const engine = queryParams.get('engine');
  const useAgents = queryParams.get('use_agents');
  const isKSP = queryParams.get('provider') === 'ksp';
  const dummy = queryParams.get('dummy');
  // Store to local component if needed
  this.eventId = eventId;

  this.$store.commit('setEventId', eventId);
  this.$store.commit('setApiKey', apiKey);
  this.$store.commit('setMarket', market);
  this.$store.commit('setService', service);
  this.$store.commit('setEngine', engine);
  this.$store.commit('setUseAgents', useAgents);
  this.$store.commit('setIsKsp', isKSP);
  this.$store.commit('setDummy', dummy);

  // Set current content
  const currentContent = eventId ? 'content_1' : 'content_10';
  this.$store.commit('setCurrentContent', currentContent);

  // Fetch data
  if (eventId) {
    this.$store.dispatch('fetchEventData', {
      eventId,
      market,
      apiKey,
      service,
      engine,
      useAgents,
      initial: true,
      isKSP,
      dummy,
    });
  }
  if (useAgents) {
    this.$store.dispatch('fetchAgentsWorkflow', { apiKey });
  }
},
    created() {
    // Check if we are on the /callback page
    if (window.location.pathname === "/callback") {
      auth.handleCallback();
    }
  },
  computed: {
    eventData() {
      return this.$store.state.eventData;
    },
    eventDataError() {
      return this.$store.state.eventDataError;
    },
    isLoadingEventData() {
      return this.$store.state.isLoadingEventData;
    },
    isLoadingEventDataFailed() {
      return this.$store.state.isLoadingEventDataFailed;
    }
  }
};
</script>

<style>
/* Add your global styles here */
#app {
  display: flex;
  flex-direction: column;
}
.content {
  display: flex;
}
</style>